var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loaded
        ? _c("div", [
            _c("div", [
              _c("h3", { staticClass: "groups-header" }, [
                _vm._v(
                  "\n                Data Sets and Distributions\n                "
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-info btn-sm pull-right",
                    attrs: {
                      title:
                        "You can also hover over the left border and change the size of the tree.",
                    },
                    on: { click: _vm.toggleTree },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.showTree ? "Hide tree" : "Show tree") +
                        "\n                "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "panel panel-default panel-heading dataset-breadcrumbs",
                  attrs: { id: "breadcrumbs" },
                },
                _vm._l(_vm.reversedCrumbs, function (group, index) {
                  return _c("span", { key: group.uuid }, [
                    index > 0 ? _c("strong", [_vm._v(" / ")]) : _vm._e(),
                    _vm._v(" "),
                    index === 0 || index < _vm.reversedCrumbs.length - 1
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                _vm.selectCrumbs(
                                  _vm.selectedCrumbs.slice(
                                    _vm.selectedCrumbs.length - (index + 1)
                                  )
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  group.dsName ? group.dsName : group.name
                                ) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _c("em", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(group.dsName ? group.dsName : group.name) +
                              "\n                    "
                          ),
                        ]),
                  ])
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { ref: "displayContainer", staticClass: "display-container" },
              [
                _c(
                  "vue-resizable",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showTree,
                        expression: "showTree",
                      },
                    ],
                    staticClass: "tree-display",
                    attrs: {
                      active: ["r"],
                      width: _vm.treeWidth,
                      maxWidth: _vm.maxTreeWidth,
                      height: _vm.treeHeight,
                    },
                    on: { "resize:end": _vm.handleTreeResize },
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "treeDisplay",
                        staticClass: "panel panel-default",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "panel-body" },
                          [
                            _c("dataset-tree", {
                              attrs: {
                                id: _vm.objId,
                                "is-root": true,
                                givenRoot: _vm.root,
                              },
                              on: { selectCrumbs: _vm.selectCrumbs },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "groupDisplay",
                    staticClass: "group-display panel panel-default",
                    style: { minHeight: _vm.minGroupHeight + "px" },
                  },
                  [
                    _c("dataset-distribution-group", {
                      attrs: {
                        group: _vm.selectedCrumbs[0],
                        "is-root": _vm.root === _vm.selectedCrumbs[0],
                      },
                      on: { selectGroup: _vm.selectDisplayGroup },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _c("Loading", { staticClass: "full-display" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }